<template>
  <div>
    <div class="text-sm text-center m-auto uppercase my-4 tracking-wider">
      {{ $t("fixed.menu.orders") }}
    </div>
    <div
      v-if="!orders.length"
      class="text-xs text-center my-4 text-slate-400 dark:text-slate-500"
    >
      {{ $t("fixed.ordersEm") }}
    </div>
    <div v-else class="grid-1">
      <div
        v-for="order in orders"
        :key="order.id"
        class="p-4 rounded-xl light2 between"
        @click="$router.push(`/order/${order.id}`)"
      >
        <div class="text-xs text-slate-500 dark:text-slate-400 uppercase">
          {{ $t("fixed.code") }}
          <span
            class="text-base text-slate-700 dark:text-white tracking-wider mx-2"
            >{{ order.code }}</span
          >
        </div>
        <div>{{ $time(order.time) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/assets/db";

export default {
  data() {
    return {
      orders: [],
    };
  },
  async created() {
    this.orders = await db.orders.toArray();
  },
};
</script>
